<div class="profile-tab">
  <!-- Left Column -->
  <div class="col-md-6">
    <div class="form-group">
      <label class="col-md-4 control-label" for="driverNo">Driver ID</label>
      <div class="col-md-6 inputSpace">
        <input
          id="driverNo"
          name="driverNo"
          type="text"
          class="form-control"
          [(ngModel)]="driver.driverNo"
          (ngModelChange)="onFieldChange()"
          [disabled]="!isEditMode || (!driver.name && !driver.lastName)"
          maxlength="16"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="avatarDriverType">Avatar Driver Type</label>
      <div class="col-md-6 inputSpace">
        <input
          id="avatarDriverType"
          name="avatarDriverType"
          type="text"
          class="form-control"
          [(ngModel)]="driver.avatarDriverType"
          disabled="true"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="driverType">Driver Type</label>
      <div class="col-md-6 inputSpace">
        <select
          class="form-control"
          [disabled]="!isEditMode"
          type="text"
          id="driverType"
          name="driverType"
          [(ngModel)]="driver.type"
          (ngModelChange)="onDriverTypeChanged()"
        >
          <option value="COMPANY DRIVER">Company Driver</option>
          <option value="OWNER OPERATOR">Owner Operator</option>
          <option value="LEASE OPERATOR">Lessor</option>
          <option *ngIf="isNewDriver || isNonAvatarDriver" value="NON-AVATAR DRIVER">
            Non-Avatar Driver
          </option>
        </select>
      </div>
    </div>

    <div class="form-group" *ngIf="driver.type === 'LEASE OPERATOR'">
      <label class="col-md-4 control-label" for="lessorId">Lessor Name</label>
      <div class="col-md-6 inputSpace">
        <select
          id="lessorId"
          name="lessorId"
          class="form-control"
          [(ngModel)]="driver.lessorId"
          (ngModelChange)="onFieldChange()"
          [disabled]="!isEditMode"
        >
          <option value="">--Select Lessor--</option>
          <option *ngFor="let lessor of lessorOwners" [ngValue]="lessor.id">
            {{ lessor.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="peopleNetId">PeopleNet ID</label>
      <div class="col-md-6 inputSpace">
        <input
          id="peopleNetId"
          name="peopleNetId"
          type="text"
          class="form-control"
          [(ngModel)]="driver.peopleNetId"
          (ngModelChange)="onFieldChange()"
          disabled="true"
          maxlength="7"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="name">First Name</label>
      <div class="col-md-6 inputSpace">
        <input
          id="name"
          name="name"
          type="text"
          class="form-control"
          [(ngModel)]="driver.name"
          (ngModelChange)="onDriverNoUpdate()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="middleName">Middle Name</label>
      <div class="col-md-6 inputSpace">
        <input
          id="middleName"
          name="middleName"
          type="text"
          class="form-control"
          [(ngModel)]="driver.middleName"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="lastName">Last Name</label>
      <div class="col-md-6 inputSpace">
        <input
          id="lastName"
          name="lastName"
          type="text"
          class="form-control"
          [(ngModel)]="driver.lastName"
          (ngModelChange)="onDriverNoUpdate()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="manager">Manager</label>
      <div class="col-md-6 inputSpace">
        <input
          id="manager"
          name="manager"
          type="text"
          class="form-control"
          [(ngModel)]="driver.manager"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="homeAddress">Home Address</label>
      <div class="col-md-6 inputSpace">
        <input
          id="homeAddress"
          name="homeAddress"
          type="text"
          class="form-control"
          [(ngModel)]="driver.homeAddress"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="city">City</label>
      <div class="col-md-6 inputSpace">
        <input
          id="city"
          name="city"
          type="text"
          class="form-control"
          [(ngModel)]="driver.city"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="state">State</label>
      <div class="col-md-6 inputSpace">
        <select
          id="state"
          name="state"
          class="form-control"
          [(ngModel)]="driver.state"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        >
          <option value="">--Select State--</option>
          <option *ngFor="let state of states" [ngValue]="state.abbreviation">
            {{ state.fullName }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="zipCode">Zip</label>
      <div class="col-md-6 inputSpace">
        <input
          id="zipCode"
          name="zipCode"
          type="text"
          class="form-control"
          [(ngModel)]="driver.zipCode"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="cellphone">Phone</label>
      <div class="col-md-6 inputSpace">
        <input
          id="cellphone"
          name="cellphone"
          type="text"
          class="form-control"
          [inputMask]="phoneMask"
          [(ngModel)]="driver.cellphone"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="email">Email</label>
      <div class="col-md-6 inputSpace">
        <input
          id="email"
          name="email"
          type="email"
          class="form-control"
          [(ngModel)]="driver.email"
          (ngModelChange)="onFieldChange()"
          [disabled]="isAvatarLocked"
        />
      </div>
    </div>
  </div>

  <!-- Right Column -->
  <div class="col-md-6">
    <div class="form-group">
      <label class="col-md-4 control-label" for="emergencyContName">Emergency Contact</label>
      <div class="col-md-6 inputSpace">
        <input
          id="emergencyContName"
          name="emergencyContName"
          type="text"
          class="form-control"
          [(ngModel)]="driver.emergencyContName"
          (ngModelChange)="onFieldChange()"
          [disabled]="!isEditMode"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="emergencyContPhone">Emergency Phone</label>
      <div class="col-md-6 inputSpace">
        <input
          id="emergencyContPhone"
          name="emergencyContPhone"
          type="text"
          class="form-control"
          [inputMask]="phoneMask"
          [(ngModel)]="driver.emergencyContPhone"
          (ngModelChange)="onFieldChange()"
          [disabled]="!isEditMode"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="birthDate">Birth Date</label>
      <div class="col-md-6 inputSpace">
        <input
          *ngIf="isNonAvatarDriver && isEditMode; else birthDateReadonly"
          id="birthDate"
          name="birthDate"
          type="text"
          class="form-control"
          [inputMask]="dateInputMask"
          placeholder="mm/dd/yyyy"
          [(ngModel)]="driver.birthDate"
          (ngModelChange)="onFieldChange()"
        />
        <ng-template #birthDateReadonly>
          <div class="form-control" style="background-color: #e9ecef; cursor: not-allowed">
            {{ formatDateOnly(driver.birthDate) }}
          </div>
        </ng-template>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="taxId">Tax ID</label>
      <div class="col-md-6 inputSpace">
        <input
          id="taxId"
          name="taxId"
          type="text"
          class="form-control"
          [(ngModel)]="driver.taxId"
          (ngModelChange)="onFieldChange()"
          [disabled]="!isEditMode"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="hiredDate">Hire Dates</label>
      <div class="col-md-6 inputSpace">
        <div *ngFor="let item of driverHireDateCounter(); let i = index">
          <div style="display: flex" [style.margin-top]="i > 0 ? '5px' : '0'">
            <div style="flex: 1; min-width: 43%; width: 43%">
              <div
                *ngIf="i == 0 && !(isNonAvatarDriver && isEditMode)"
                class="form-control"
                style="background-color: #e9ecef; cursor: not-allowed"
              >
                {{ formatDateOnly(driver.hiredDate) }}
              </div>
              <input
                *ngIf="i == 0 && isNonAvatarDriver && isEditMode"
                id="hiredDatePrimary"
                name="hiredDatePrimary"
                type="text"
                class="form-control"
                [inputMask]="dateInputMask"
                placeholder="mm/dd/yyyy"
                [(ngModel)]="driver.hiredDate"
                (ngModelChange)="onFieldChange()"
                aria-label="Primary hire date"
              />
              <input
                *ngIf="i > 0"
                id="hiredDate"
                name="hiredDate"
                type="text"
                class="form-control"
                [inputMask]="dateInputMask"
                placeholder="mm/dd/yyyy"
                [(ngModel)]="driver.driverHireDates[i - 1].hiredDate"
                (ngModelChange)="onFieldChange()"
                [disabled]="!isEditMode"
                aria-label="Additional hire date"
              />
            </div>
            <div style="display: flex">
              <label style="flex: 1"></label>
              <div style="display: flex">
                <div style="flex: 1">
                  <input
                    *ngIf="i == 0"
                    id="hiredDateTo0"
                    name="hiredDateTo0"
                    type="text"
                    class="form-control"
                    [inputMask]="dateInputMask"
                    placeholder="mm/dd/yyyy"
                    [(ngModel)]="driver.hiredDateTo"
                    (ngModelChange)="onFieldChange()"
                    [disabled]="!isEditMode"
                    aria-label="Primary hire end date"
                  />
                  <input
                    *ngIf="i > 0"
                    id="hiredDateTo"
                    name="hiredDateTo"
                    type="text"
                    class="form-control"
                    [inputMask]="dateInputMask"
                    placeholder="mm/dd/yyyy"
                    [(ngModel)]="driver.driverHireDates[i - 1].hiredDateTo"
                    (ngModelChange)="onFieldChange()"
                    [disabled]="!isEditMode"
                    aria-label="Additional hire end date"
                  />
                </div>
                <button
                  *ngIf="i == 0 && isEditMode"
                  class="button-form-control"
                  (click)="addDriverHireDate()"
                  aria-label="Add hire date"
                >
                  +
                </button>
                <button
                  *ngIf="i > 0 && isEditMode"
                  class="button-form-control"
                  (click)="removeDriverHireDate(i)"
                  aria-label="Remove hire date"
                >
                  -
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="rehire">Eligible Rehire</label>
      <div class="col-md-6 inputSpace">
        <p-checkbox
          id="rehire"
          name="rehire"
          [(ngModel)]="driver.rehire"
          (ngModelChange)="onFieldChange()"
          binary="true"
          [disabled]="!isEditMode"
        ></p-checkbox>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="settlementEmail">Settlement Emails</label>
      <div class="col-md-6 inputSpace">
        <div
          *ngFor="let email of settlementEmails; let i = index; trackBy: trackByIndex"
          style="display: flex; margin-bottom: 5px"
        >
          <input
            type="email"
            class="form-control"
            [name]="'settlementEmail' + i"
            [id]="'settlementEmail' + i"
            [(ngModel)]="settlementEmails[i]"
            (ngModelChange)="onSettlementEmailChange()"
            [disabled]="!isEditMode"
            placeholder="email@example.com"
            aria-label="Settlement email address"
          />
          <button
            *ngIf="isEditMode"
            class="button-form-control"
            (click)="removeSettlementEmail(i)"
            [disabled]="settlementEmails.length === 1"
            aria-label="Remove settlement email"
          >
            -
          </button>
        </div>
        <button
          *ngIf="isEditMode"
          class="button-form-control"
          (click)="addSettlementEmail()"
          style="margin-top: 5px"
          aria-label="Add settlement email"
        >
          +
        </button>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="terminationDate">Termination Date</label>
      <div class="col-md-6 inputSpace">
        <div class="form-control" style="background-color: #e9ecef; cursor: not-allowed">
          {{ formatDateOnly(driver.terminationDate) }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="terminationType">Termination Type</label>
      <div class="col-md-6 inputSpace">
        <input
          id="terminationType"
          name="terminationType"
          type="text"
          class="form-control"
          [(ngModel)]="driver.terminationType"
          (ngModelChange)="onFieldChange()"
          disabled="true"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="dateOfLastMovement">Date of Last Movement</label>
      <div class="col-md-6 inputSpace">
        <input
          id="dateOfLastMovement"
          name="dateOfLastMovement"
          type="text"
          class="form-control"
          [value]="getDateOfLastMovement()"
          disabled="true"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="autoTransmissionOnly"
        >Auto Transmission Only</label
      >
      <div class="col-md-6 inputSpace">
        <p-checkbox
          id="autoTransmissionOnly"
          name="autoTransmissionOnly"
          [(ngModel)]="driver.autoTransmissionOnly"
          (ngModelChange)="onFieldChange()"
          binary="true"
          [disabled]="!isEditMode"
        ></p-checkbox>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-4 control-label" for="isActive">Active</label>
      <div class="col-md-6 inputSpace">
        <p-checkbox
          id="isActive"
          name="isActive"
          [(ngModel)]="driver.isActive"
          (ngModelChange)="onFieldChange()"
          binary="true"
          disabled="true"
        ></p-checkbox>
      </div>
    </div>
  </div>
</div>
